import { DumpTruckStatusTypes } from "./enum";
import { grey } from "@mui/material/colors";

const DumpTruckStatusColors: Record<DumpTruckStatusTypes, string> = {
    [DumpTruckStatusTypes.PENDING]: '#FFC107',
    [DumpTruckStatusTypes.ACTIVE]: '#87CEEB',
    [DumpTruckStatusTypes.UNLOADED]: '#32CD32',
}

export const getDumpTruckStatusColor = (status: DumpTruckStatusTypes) => DumpTruckStatusColors[status] || grey[500];
